// import api from "api/axios";

// export const fetchNotifications = () => api.get("/push-notifications");
// export const fetchNotificationById = (id) => api.get(`/push-notifications/${id}`);
// export const createNotification = (data) => api.post("/push-notifications", data);
// export const updateNotification = (id, data) => api.put(`/push-notifications/${id}`, data);
// export const deleteNotification = (id, data) => api.delete(`/push-notifications/${id}`, { data });


import api from "api/axios";

// 1. Fetch Notifications List
export const getNotifications = async (params) => {
  const response = await api.get("/push-notifications", { params });
  return response.data;
};

// 2. Create / Schedule Notification
export const createNotification = async (data) => {
  const response = await api.post("/push-notifications", data);
  return response.data;
};

// 3. Resend Notification
export const resendNotification = async (id) => {
  const response = await api.post(`/push-notifications/${id}/resend`);
  return response.data;
};

// 4. Delete Notification
export const deleteNotification = async (id, data) => {
  const response = await api.delete(`/push-notifications/${id}`, { data });
  return response.data;
};